import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
export class BloqueadoColegioComponent implements OnInit {
public mensagem:string = "";
/**
 * @param {?} rotaAtivada
 */
constructor(private rotaAtivada: ActivatedRoute) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rotaAtivada.params.subscribe(p => {
      this.mensagem = p['mensagem'];
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-bloqueado-colegio',
  template: `
    <div align="center">
      <h1>Sem Acesso.</h1>
      <h3>{{mensagem}}</h3>
    </div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ActivatedRoute, },
];
}

function BloqueadoColegioComponent_tsickle_Closure_declarations() {
/** @type {?} */
BloqueadoColegioComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BloqueadoColegioComponent.ctorParameters;
/** @type {?} */
BloqueadoColegioComponent.prototype.mensagem;
/** @type {?} */
BloqueadoColegioComponent.prototype.rotaAtivada;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
